/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// NOTE TO THE FUTURE!
// Don't nest ul/ol in p tags, react doesn't like it

const _helpMessages = {
    'default': function () {
        return 'This is a help message, brave and true';
    },
    autoHashtag: function (service) {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_TUMBLR:
                return (
                    <div>
                        <p className='dialog'>If your RSS feed items include 'category' tags, those tags will be used to create Tumblr tags on your posts.</p>
                    </div>
                );

            default:
                return (
                    <div className="dialog">
                        We'll scan your feed and web pages for topic / category tags and automatically include them as hashtags in your posts.
                        <p className="dialog">We'll look in your RSS feed items  for ‘category tags’ and we’ll scan your pages for &lt;article:tags&gt;.</p>
                        <p className="dialog">If you use WordPress, a) categories typically map to the categories you set for your post, and b) article tags typically map to the tags you define for your post.</p>
                        <p className="dialog">There are three different placement options for these hashtags:</p>
                        <ul className='dialog'>
                            <li><strong>Start of Post:</strong> Auto Detected Hashtags, up to a maximum of 5, will be placed between any defined prefixes and the item content.</li>
                            <li><strong>End of Post:</strong> Auto Detected Hashtags, up to a maximum of 5, will be placed after your content ahead of any suffixes added to the item content.</li>
                            <li><strong>Inline:</strong> If any of the categories are matched in the item text (title or body), the matched text will be turned into a Auto Detected Hashtag.</li>
                        </ul>
                    </div>
                );
        }

    },
    smartHashtags: function () {
        return (
            <div className="dialog">
                Automatically include AI generated hashtags based on your post content.
            </div>
        );
    },
    postAction: function () {
        return (
            <div>
                The call to action text for the button included in your posts.
            </div>
        );
    },
    postTitle: function () {
        return (
            <div>
                The item title will appear as part of the status update.
            </div>
        );
    },
    postBody: function () {
        return (
            <div>
                Choose this option to post item Body content. You may select which portion of
                the Body (Summary Content or Full Content) from the feed source set up
                under advanced options.
            </div>
        );
    },
    postUrl: function () {
        return (
            <div>
                Post the shortened link to the item content.
            </div>
        );
    },
    prefixSuffix: function () {
        return (
            <div>
                Adding a prefix to your post places any text you place in the "Start items with" box to the
                beginning of your post. This text will also be placed before any prefixes you add to the
                source. Any post suffixes will be added after your post content and any source suffixes.
            </div>
        );
    },
    prefixSpace: function () {
        return (
            <div>
                A space is inserted after the prefix you define and the rest of your post content.
                If you'd like to remove this space, check the 'No space after prefix' checkbox.
            </div>
        );
    },
    postfixSpace: function () {
        return (
            <div>
                A space is inserted after the end of your post content and the suffix you define.
                If you'd like to remove this space, check the 'No space before suffix' checkbox.
            </div>
        );
    },
    postContent: function () {
        return (
            <div>
                dlvr.it will include the selected content elements in your posts.
            </div>
        );
    },
    postStyle: function (service) {
        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_FACEBOOK:
                return (
                    <div>
                        There are two options for how the posts to Facebook can be displayed:<br /><br />
                        <strong>Shared Link</strong>: Link will be posted as a Facebook Shared Link. Link Title and Summary will be posted using the content from your feed item. An optional thumbnail image will be included in the post based on the setting below.<br /><br />
                        <strong>Shared Link using OpenGraph</strong>: Link will be posted as a Facebook Shared Link as above. Title, Summary, and Thumbnail will be automatically detected by Facebook from your website using <a href="http://ogp.me/" target="_blank">OpenGraph tags</a>.&nbsp; If you do not have OpenGraph tags implemented, Facebook will make its best guess at the most appropriate content.<br /><br />
                        <strong>Status Update</strong>: Post will be made as a Status Update. You may select which elements to include: Title, Body, and/or Link.
                    </div>
                );

            case constants.POST_SVC_LINKEDIN:
                return (
                    <div>
                        There are two options for how the posts to LinkedIn can be displayed:<br /><br />
                        <strong>Shared Link</strong>: Title, Summary, Link and an optional thumbnail image will be included in the post.<br /><br />
                        <strong>Status Update</strong>: Post will be made as a Status Update. You may select which elements to include: Title, Body, and/or Link. (420 characters maximum)
                    </div>
                );

            case constants.POST_SVC_TUMBLR:
                return (
                    <div>
                        There are two options for how the posts to Tumblr can be displayed:<br /><br />
                        <strong>Link</strong>: Post will be made as a 'link' style post.<br /><br />
                        <strong>Text</strong>: Post will be made as a standard text style post.<br /><br />
                        Direct posts that contain a photo will always be made as 'photo' style posts.
                    </div>
                )

        }

    },
    includeSummaryTitle: function () {
        return (
            <div>
                This text will be used as the message for the post with the link being attached below.
            </div>
        );
    },
    includeSummaryBody: function () {
        return (
            <div>
                This text will be used as the message for the post with the link being attached below.
            </div>
        )
    },
    thumbStyle: function (service) {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_FACEBOOK:
                return (
                    <div>
                        When Shared Link is enabled, there are four options for determining the image thumbnail posted to Facebook:<br /><br />
                        <strong>Auto-Detected by Facebook</strong>: The Facebook API will attempt to determine the thumbnail to use by reading the destination URL<br /><br />
                        <strong>Auto-Detected from Item Content</strong>: dlvr.it will use the first image located in the item content as the thumbnail.<br /><br />
                        <strong>Manual</strong>: You manually enter the URL of an image you would like to use as your thumbnail.  This image will be used on every post.<br /><br />
                        <strong>No Thumbnail</strong>: No thumbnails will be used.
                    </div>
                );

            case constants.POST_SVC_LINKEDIN:
                return (
                    <div>
                        When Shared Link is enabled, there are four options for determining the image thumbnail posted to LinkedIn:<br /><br />
                        <strong>Auto-Detected by LinkedIn</strong>: The LinkedIn API will attempt to determine the thumbnail to use by reading the destination URL<br /><br />
                        <strong>Auto-Detected from Item Content</strong>: dlvr.it will use the first image located in the item content as the thumbnail.<br /><br />
                        <strong>Manual</strong>: You manually enter the URL of an image you would like to use as your thumbnail.  This image will be used on every post.<br /><br />
                        <strong>No Thumbnail</strong>: No thumbnails will be used.
                    </div>
                );



        }

    },
    thumbUrl: function (service) {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_FACEBOOK:
                return (
                    <div>
                        <strong>Auto-Detected from Item Content</strong>: This image will be used as a last choice if no other thumbnail can be detected.<br /><br />
                        <strong>Manual</strong>: This image will be used as the thumbnail for for all Shared Link posts, and leaving this field empty is the same as setting Thumbnail Style to "Disabled"
                    </div>
                );

            default:
                return (
                    <div>
                        Specify the thumbnail to be used for all Shared Links.  Leaving this field empty is the same as setting Thumbnail Style to "Disabled"
                    </div>
                );
        }

    },
    postPrivacy: function (service) {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_FACEBOOK:
                return (
                    <div>
                        <b>Default</b>: Posts will appear with your default Facebook privacy settings.<br /><br />
                        <b>Everyone</b>: Everyone on the internet will be able see posts made with this privacy setting. (<a href="http://www.facebook.com/help/?faq=14444" target="_blank">Facebook's FAQ</a>)<br /><br />
                        <b>All Friends</b>: All or your friends will be able to see posts made with this privacy setting.<br /><br />
                        <b>Networks and Friends</b>: Anyone who is a friend, or is listed in a network that you are a member of, will be able to see posts made with this privacy setting.<br /><br />
                        <b>Friends of Friends</b>: Second-Level Friends (Anyone who is friends with one of your friends) will be able to see posts made with this privacy setting. (<a href="http://www.facebook.com/help/?faq=12241" target="_blank">Facebook's FAQ</a>)<br />
                        <i>Note</i>: Privacy settings are ignored when posting to Group or Page destinations
                    </div>
                );

            case constants.POST_SVC_LINKEDIN:
                return (
                    <div>
                        <b>Contacts</b>: Posts will be visible to your LinkedIn contacts (personal profiles only).<br /><br />
                        <b>Logged In</b>: Posts will be visible to any logged-in LinkedIn user<br /><br />
                        <b>Public</b>: Posts are visible to anyone who views your user or company profile (default for company profiles).
                    </div>
                );
        }
    },
    postDarkQR: function () {
        return (
            <div>
                When a post has no image of its own, we build one: the destination's domain, your
                post's title, and the QR code.<br /><br />
                Choose whether that card is built dark or light. It changes nothing about
                posts that already have an image — the code is added to the corner of those, and
                takes no background of its own.
            </div>
        );
    },
    postQrCode: function () {
        return (
            <div>
                Turn this on to add a scannable QR code for the link. We put it in the corner of
                your post's image, or post it as an image of its own when there isn't one.<br /><br />
                Posts carrying a video can't include one, because X won't accept a video and an
                image together.
            </div>
        );
    },
    postQrCodeInstagram: function () {
        return (
            <div>
                Turn this on to add a scannable QR code for the link. We put it in the corner of
                your post's first image.<br /><br />
                Reels and other posts with only video can't include one, because there is no image
                to put it on.
            </div>
        );
    },
    postImages: function (service) {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_DISCORD:
                return (
                    <div>
                        Your post will include a link preview.
                    </div>
                );

            default:
                return (
                    <div>
                        Make full-sized photo-style posts with title and link as a message.<br /><br />
                        Posts will NOT include summary of your article.
                    </div>
                );
        }
    },
    ignorePrefix: function () {
        return (
            <div>
                Source and destination prefix text will not appear in the status update.
            </div>
        )
    },
    ignorePostfix: function () {
        return (
            <div>
                Source and destination suffix text will not appear in the status update.
            </div>
        )
    },
    postFullUrl: function () {

        let constants = this.props.app.config.constants;

        switch (parseInt(service, 10)) {
            case constants.POST_SVC_FACEBOOK:
                return (
                    <div>
                        When making Shared Link-style posts, use the full item URL instead of a shortened URL.
                        This can benefit Facebook "Like" statistics, but prevents dlvr.it from gathering any
                        click statistics from Facebook posts.
                    </div>
                );

            default:
                return null;
        }
    },
    staticTitle: function () {

        return (
            <div>
                Use this title for each item posted to the feed.
            </div>
        );

    },
    messageText: function () {
        return (
            <div>
                This text will be used as the summary for the post with the link being attached below.
            </div>
        );
    },
    autoSentiment: function () {
        return (
            <div>
                Choose this option to automatically post sentiment based on item categories or hashtags (#bullish, #bearish).
            </div>
        )
    },
    postAsRetweet: function () {
        return (
            <div>
                Post content that originated from a X (Twitter) input source as an official retweet, not just a copy of the posted text.  All content formatting options will be ignored and the original Tweet will appear as a Retweet in the target Timeline.
            </div>
        );
    },
    feedUrl: function () {
        return (
            <div>
                We do not allow updates to the Feed URL of a source feed. We do this in order to maintain the consistency of the statistics we record for each of your feeds, and to avoid the unexpected posting of multiple items from an updated Feed URL.<br /><br />
                If you would like to use a different Feed URL as your source, you can easily add the new source Feed URL to your route.
            </div>
        );
    },
    pinterestFeed: function () {
        return (
            <div>
                <p>To connect your Pinterest account to dlvr.it, you’ll need your Pinterest Username.</p>
                <p>To find your Pinterest Username, log into Pinterest and go to {"https://www.pinterest.com/settings/"}.
                    {"Scroll down to the Profile > Username section. Your username will look something like"}
                    this {"http://pinterest.com/username"}. Just enter your username in dlvr.it and not the
                    entire URL. (Please don't include this part: {"http://pinterest.com/"})</p>
                <p>You can optionally connect a specific Pinterest Board to dlvr.it. {"You'll"} need to enter your Pinterest username and
                    the name of the Pinterest Board. dlvr.it cannot connect to secret Pinterest Boards.</p>
            </div>
        );
    },
    postImagesInput: function () {
        return (
            <div>
                Activate photo posting and dlvr.it will share photos to your social networks! When dlvr.it finds shareable
                images in your feed content we'll make photo posts to your socials networks.
            </div>
        )
    },
    itemTrickle: function () {
        return (
            <div>
                <strong>Trickle Off:</strong> updates your feed and looks for newly published items to post. New items (up to the "Max Number of New Items to Post per Update Period" set for your feed) will post. Newly published items not posted during an update period will be marked as 'seen' and are not eligible for posting later. For example, if during the feed update period your feed has 7 new items, and the "Max Number of New Items to Post per Update" is set to 5, then 5 new items will post and 2 will be marked 'seen' and will never post.<br /><br />
                <strong>Post Oldest Items First:</strong> Items will be posted beginning with the oldest and working forward. During each feed update, the oldest, previously unposted items (up to the "Max Number of New Items to Post per Update Period") will post. Items not posted during feed update will be eligible for posting later.<br /><br />
                <strong>Post Newest Items First:</strong> Items will be posted beginning with the newest then working back. During each feed update period, the newest, previously unposted items (up to the "Max Number of New Items to Post per Pull") will post. Items not posted during feed update will be eligible for posting later.<br /><br />
                <strong>Randomize Item Order:</strong> Items will be posted in a random order. Items not posted during feed update will be eligible for posting later.
            </div>
        )
    },
    pushEnabled: function () {
        return (
            <div>
                <p className="dialog">
                    If your feed is PuSH enabled, dlvr.it will subscribe to your hub and receive new items as you publish. <a href="https://support.dlvrit.com/hc/en-us/articles/200402424-How-do-I-enable-real-time-updates-with-dlvr-it-" target="_blank">More on dlvr.it and PuSH.</a>
                </p>
                <p className="dialog">
                    Turn this option off if you're experiencing posting issues with your PuSH enabled feed.
                </p>
            </div>
        )
    },
    searchReplace: function () {
        return (
            <div>
                <p>
                    Define rules to replace and/or remove text from your feed items. If you set multiple rules, the text modifications will happen in sequential order (top to bottom). To reorder the sequence, drag and drop the rules into your desired order.<br /><br />
                    dlvr.it modifies the raw feed item text. Any prefixes/suffixes and/or auto hashtags will be added after the text modifcations and will not be replaced or removed.<br /><br />
                </p>
                <p>
                    The Replace/Remove operations occur prior to feed items being placed into the curation queue.
                </p>
                <div>
                    <strong>Options:</strong>
                    <ul>
                        <li><strong>Case Sensitive:</strong> Finds text only if the case matches.</li>
                        <li><strong>Match whole word:</strong> Finds text only if it appears as a whole word. For instance, if looking for the text "state", a) the word "state" will be found, while b) "statement" will not.<br /><br />If unchecked, dlvr.it will find text that appears anywhere in a sequence. For instance, if looking for the text "state", all of the following will be found: "state", "statement", "understated", etc.</li>
                        <li><strong>Search Fields:</strong> Select the fields where dlvr.it will search for the text to replace or remove.</li>
                    </ul>
                </div>
            </div>
        )
    },
    filterBehaviorSource: function () {
        return (
            <div>
                <p>
                    <strong>Match whole words:</strong>&nbsp;Applies filters on words/phrases only if they appear as a whole word. For instance, if filtering on the word "state", a) "state" will trigger the filter, while b) "statement" will not.<br /><br />
                    <strong>Match sequence anywhere:</strong>&nbsp;Applies filters on words/phrases if they appear anywhere in a sequence.  For instance, if filtering on the word "state", all of the following will trigger the filter: "state", "statement", "understated", etc.<br /><br />
                </p>
            </div>
        )
    },
    useGeo: function () {
        return (
            <div>
                <p>
                    dlvr.it will pass your feed location info, if available, to X (Twitter) when we post.
                </p>
                <p>
                    You'll need to turn on location in your X (Twitter) account - log into  <a href='http://twitter.com'>{"http://twitter.com"}</a>, and under 'Settings', make sure the 'Add a location to your tweets' option is checked.
                </p>
            </div>
        )
    },
    defaultGeo: function () {
        return (
            <div>
                <p>
                    Set your feed's default location and we'll pass X (Twitter) the default geo coordinates, even if your feed item doesn't contain location info.
                </p>
                <p>
                    {"You'll"} need to turn on location in your X (Twitter) account - log into  <a href='http://twitter.com'>{"http://twitter.com"}</a>, and under {"'Settings'"}, make sure the {"'Add a location to your tweets'"} option is checked.
                </p>
                <div>
                    Use the embedded map to choose your default location:
                    <ul>
                        <li>Pan the map by clicking and dragging, or using the embedded control on the top left of the map.</li>
                        <li>Zoom in or out on the map by using the embedded controls or the scroll wheel.</li>
                        <li>Click the map to set your location, indicated by the red marker.</li>
                        <li>Click the red marker again to remove your location.</li>
                    </ul>
                </div>
            </div>
        );
    },
    overrideItemGeo: function () {
        return (
            <p>
                By choosing this option, your feed's default location will override any location information included in feed items.
            </p>
        )
    },
    preferSummary: function () {
        return (
            <div>
                <p>
                    <strong>Prefer Summary Content (default):</strong> If available, Summary Content will post. If Summary Content
                    is not available, Full Content will post.<br /><br />
                    <strong>Prefer Full Content (default):</strong> If available, Full Content will post. If
                    Full Contentis not available, Summary Content will post.<br /><br />
                </p>
            </div>
        )
    },
    useDateFlag: function () {
        return (
            <div>
                <p>
                    Items with updated timestamps will be considered 'new' and eligible for re-posting with respect to the other limits defined on this feed.
                </p>
            </div>
        )
    },
    ignoreOrigLink: function () {
        return (
            <div>
                <p>
                    <i>Applies to FeedBurner hosted RSS Feeds only.</i><br /><br />
                    Feedburner add tracking links to feed items to enable click tracking.
                    By default dlvr.it passes the original link (untouched by Feedburner) through to your shortening service.<br /><br />
                    Select this option if you prefer dlvr.it to pass your Feedburner tracking links to your shortening service.
                </p>
            </div>
        )
    },
    sharedLink: function () {
        return (
            <div>
                <p>
                    We'll post as a shared link where applicable
                </p>
            </div>
        )
    },
    updateWindow: function () {
        return (
            <div>
                During an update window, dlvr.it will check your feed and post per the update interval defined in your Feed Update settings.
            </div>
        )
    },
    urlAppend: function () {
        return (
            <div>
                <p>
                    Any text you place in the tracking code box will be added to the destination (long) url when
                    a user clicks on your shortened link. Use the variable options to customize tracking tags for
                    precise tracking of traffic sources. Dlvr.it will automatically add any necessary "?" or "&amp;"
                    at the start of the string.
                </p>
            </div>
        )
    },
    trackingVariables: function () {
        return (
            <div>
                <h3>Using tracking and variables</h3><br />
                <p>
                    Any text you place in the tracking code box will be added to the destination (long) url when a
                    user clicks on your shortened link. You can use the variables to customize the info passed to
                    your site analytics system with each click.
                </p>
                <p>
                    Using the variables let your track and report more granularly on traffic sources.
                    For example, if you have both X (Twitter) and Facebook accounts use the [desttype] variable,
                    and we'll replace it in your tracking tag with "twitter" or "facebook", depending
                    on where the click comes from.
                </p>
                <p>
                    When using variables, be sure to leave the square brackets intact around the variable name.
                    For example if you include [desttype] in your tracking code, we'll know to replace that with
                    Twitter or Facebook. However, if you include desttype without the brackets, we'll simply
                    include the phrase desttype in your tracking tag.
                </p>
                <p>
                    If you're using a predefined template, you may replace the default values with any of
                    the possible variables defined in the list. You may also add additional parameters.
                    If you add additional parameters to the end of the string, such as utm_term= or utm_content=,
                    be sure to precede those with an &amp;. For instance, &amp;utm_term=syndication, or &amp;utm_content=news.
                </p>
                <p>
                    If you're using custom tracking, we figure you know what you're doing. If you use our variables
                    just make sure you retain the square brackets around your desired variables.
                </p>
                <p>
                    One last note, if you change your tracking at some point in the future, that change will only
                    affect new links generated for new posts. The old links will retain their old tracking
                    information. If you want to turn tracking off, just delete the text in the
                    box and hit the 'save options' button.
                </p>
            </div>
        );
    },
    shortenerOverride: function () {
        return (
            <div>
                <p>
                    All items posted through this social will use the selected shortener service.<br /><br />
                    If you choose to use a shortener other than {"dlvr.it's"} shortening service, dlvr.it will not track and report on detailed click stats and trends.<br /><br />
                    Add additional shortening accounts to dlvr.it at Socials {"->"} Short Links. <br /><br />
                    Your default shortener will automatically be selected when you create new routes.
                </p>
            </div>
        )
    },
    routeShortenerOverride: function () {
        return (
            <div>
                <p>
                    All items posted through this route will use the selected shortener service.<br /><br />
                    If you choose to use a shortener other than {"dlvr.it's"} shortening service, dlvr.it will not track and report on detailed click stats and trends.<br /><br />
                    Add additional shortening accounts to dlvr.it at Socials {"->"} Short Links. <br /><br />
                    Your default shortener will automatically be selected when you create new routes.
                </p>
            </div>
        )
    },
    shortenerBitly: function () {
        return (
            <p>
                To shorten links using bit.ly you'll first need a <a href="http://bit.ly" target="_blank">bit.ly</a> account.
                Connect your bit.ly simply by following the steps in the Add shortener dialog.<br /><br />
            </p>
        );
    },
    customDomain: function () {
        return (
            <div>
                <p>
                    Before your set up and use your custom short domain, you'll need to:
                </p>
                <ol>
                    <li>Register a domain<br />
                        You need to have ownership and control of your domain. If you don't already own a domain, you'll need to
                        register one.
                        For ideas & suggestions for a short domain based on your brand, try the domain name suggestion service,
                        <a href="http://domai.nr" target="_blank">domai.nr</a>.
                        You can also consult the <a href="http://en.wikipedia.org/wiki/List_of_Internet_top-level_domains" target="_blank">list of top-level domains (TLDs) on Wikipedia</a> for ideas.
                    </li>
                    <li>Update your custom domain's DNS settings<br />You will need to make one of the following
                        DNS changes:<br />
                        <ol>
                            <li>Set a DNS A Record making your custom short domain point to 54.213.66.64</li>
                            <li>If you are using a subdomain (subdomain.your-custom-domain.com) for your custom
                                short domain, set a CNAME in your DNS record that points your subdomain to <strong>dlvr.it</strong>
                            </li>
                        </ol>
                    </li>
                </ol>
                <p>
                    {"By default visitors to your custom domain root (http://yourcustomdomain.com) will be directed to http://dlvr.it."}
                </p>
                <br />
                <p>If you have the Ultimate plan or above, set the redirect URL to point visitors root
                    visitors to your own URL.
                </p>
                <br />
                <p>
                    It can take up to 24 hours or more for changes to your DNS settings to take effect,
                    though many updates are completed much faster. Until the changes take effect,
                    you will not be able to set up and use your custom short domain in dlvr.it.
                    This protects against publishing broken links.
                </p>
            </div>
        );
    },
    customShortener: function () {
        return (
            <div>
                <p>
                    dlvr.it allows you to utilize any third party shortening service that provides API access and returns the
                    shortened URL in a plain text format.
                </p>
                <p>
                    To set up a third party shortener, first, enter a name for the shortening service. We suggest using the short
                    url domain. For instance, if you are using su.pr short links, we recommend using the name su.pr.
                </p>
                <p>
                    Next, add the URL dlvr.it should use for communicating with your shortening service's API. Replace the actual
                    URL in the API request with the macro @URL@ (make sure URL is all caps).
                </p>
                <p>
                    For instance, if you are using su.pr to shorten links: {"http://su.pr/api/simpleshorten?url=@URL@"}
                </p>
                <p>
                    {"You may includee as many parameters in the API request as necessary. For instance: http://su.pr/api/simpleshorten?login=janedoe&amp;apiKey=48d1d55b5a48d4ec2c5152f4419b3c44&amp;url=@URL@<br/>"}
                </p>
                <p>
                    {"dlvr.it expects responses fro the API to be in a plain text format such as:<br/>http://su.pr/abc123"}
                </p>
                <p>
                    At this time, we're not processing JSON or XML formatted responses.
                </p>
            </div>
        )
    },
    linkWrapper: function () {
        return (
            <div>
                This option allows you to set your shortener of choice to display in your posts, and allows dlvr.it to track and report your stats.
            </div>
        )
    },
    cvv: function () {
        let imageUrl = this.props.app.config.assetsUrl + this.props.app.config.imageUrl;

        return (
            <div>
                <img className="brands-image" src={imageUrl + '/payment-types/cvv.jpg'} />
            </div>
        );
    },
    replay: function () {

        return (
            <div>
                <p>Recycle your content for maximum exposure.</p>
                <p>dlvr.it posts your content, then we'll make it available for recycling.</p>
                <p>Increase your traffic, encourage more shares, and reach new audiences.</p>
            </div>
        );
    },
    everqueueFrequency: function () {
        return (
            <div>
                <p>Set how often you would like EverQueue items to be added to your regular Queue. <a href="https://support.dlvrit.com/hc/en-us/articles/115004159234-How-to-Use-EverQueue" target="_blank">Learn more.</a></p>
            </div>
        );
    },
    facebookProfiles: function () {
        return (
            <div>
                <p>Facebook has updated their API and services like dlvr.it may no longer post to personal profiles. Pages or groups are still fully supported. <a href="https://support.dlvrit.com/hc/en-us/articles/360007291174" target="_blank">Learn more.</a></p>
            </div>
        );
    },
    hashtagSettings: function () {
        return (
            <div>
                <p>TODO -- Add help</p>
            </div>
        );
    },
    hashtagStatic: function () {
        return (
            <div>
                <p>Type in the hashtags you'd like to appear on every item we post for you.</p>
            </div>
        );
    },
    hashtagPool: function () {
        return (
            <div>
                <p>Set up a list of hashtags, and for each post you publish, we'll attach a unique selection of your tags to the post (up to the defined max).</p>
            </div>
        );
    },
    socialInputs: function () {
        return (
            <div>
                <p>We'll <strong>post items from</strong> the social media page you select below.</p>
                <p><i>Next you'll connect the social media pages that we <strong>post items to</strong>.</i></p>
            </div>
        );
    },
    twitterList: function () {
        return (
            <div>
                <p>The ID is the numeric value which was assigned to the list when it was created.</p>
                <p>The ID can be found by copying the numbers at the end of the list URL on X (Twitter).</p>
                <p>example: <a href="https://twitter.com/i/lists/79191745">https://twitter.com/i/lists/<strong>79191745</strong></a></p>
            </div>
        );
    },
    allowCropping: function () {
        return (
            <div>
                <p>Automatically crop and resize images to fit Instagram's requirements.</p>
            </div>
        );
    },
    mastodonHandle: function () {
        return (
            <div>
                <p>You can find your Mastodon handle by logging into your Mastodon account and selecting your profile.</p>
                <p>Your handle structure will be @yourusername@your.server</p>
                <p>For example: @Mastodon@mastodon.social</p>
            </div>
        );
    },
    blueskyProvider: function () {
        return (
            <div>
                <p>You can find your Bluesky handle by logging into your Bluesky account and selecting 'Settings'.</p>
                <p>Your handle appears in the 'Signed in as' section and has the form yourhandle.bsky.social</p>
            </div>
        );
    },
    blueskyPassword: function () {
        return (
            <div>
                <p>You can generate an app password for Bluesky by logging into your Bluesky account and selecting 'Settings'.</p>
                <p>Find the 'App Passwords' section.</p>
                <p>Click 'Add App Password', copy the created password and paste it into dlvr.it</p>
            </div>
        );
    },
    TTBrandDisclosure: function () {
        return (
            <div>
                <p>You are promoting yourself or your own business. This content will be classified as Brand Organic.</p>
            </div>
        );
    },
    TTBrandedContentDisclosure: function () {
        return (
            <div>
                <p>You are promoting another brand or a third party. This content will be classified as Branded Content.</p>
            </div>
        );
    },
    timezone: function () {
        return (
            <div>
                <p>Need to change the timezone on your account? Visit your <a href="/account">account page</a> to make changes.</p>
            </div>
        );
    },
    aiDisclosure: function () {
        return (
            <div>
                <p>AI responses can be inaccurate or misleading. <a href="https://support.dlvrit.com/hc/en-us/articles/31164718657435-Limitations-with-Artificial-Intelligence" target="_blank">Learn more.</a></p>
            </div>
        );
    },
    igInputNativeMedia: function () {
        return (
            <div>
                <p>
                    <strong>Native Media + Link:</strong><br />
                    Instagram photos will be displayed in your posts as full images rather
                    than an attached link. We'll add a link back to the original post in the message.
                </p>
                <p>
                    <strong>Native Media:</strong><br />
                    Instagram photos will be displayed in your posts as full images rather
                    than an attached link. We will not include a link back to the original post.
                </p>
                <p>
                    <strong>Shared Link:</strong><br />
                    Instagram posts will be shared as an attached Shared Link and link back to the original post.
                </p>
            </div>
        );
    },
    igInputCaption: function () {
        return (
            <div>
                <p>
                    <strong>Captions + Hashtags:</strong><br />
                    Your original caption and hashtags will be displayed in shared posts.
                </p>
                <p>
                    <strong>Caption:</strong><br />
                    Your original caption will be displayed in shared posts. Hashtags will not be included.
                </p>
                <p>
                    <strong>No Text:</strong><br />
                    Captions and hashtags will be excluded.
                </p>
            </div>
        );
    },
    fbInputNativeMedia: function () {
        return (
            <div>
                <p>
                    <strong>Native Media + Link:</strong><br />
                    Facebook photos will be displayed in your posts as full images rather
                    than an attached link. We'll add a link back to the original post in the message.
                </p>
                <p>
                    <strong>Native Media:</strong><br />
                    Facebook photos will be displayed in your posts as full images rather
                    than an attached link. We will not include a link back to the original post.
                </p>
                <p>
                    <strong>Shared Link:</strong><br />
                    Facebook posts will be shared as an attached Shared Link and link back to the original post.
                </p>
            </div>
        );
    },
    fbInputCaption: function () {
        return (
            <div>
                <p>
                    <strong>Captions + Hashtags:</strong><br />
                    Your original caption and hashtags will be displayed in shared posts.
                </p>
                <p>
                    <strong>Caption:</strong><br />
                    Your original caption will be displayed in shared posts. Hashtags will not be included.
                </p>
                <p>
                    <strong>No Text:</strong><br />
                    Captions and hashtags will be excluded.
                </p>
            </div>
        );
    },
    inputSource: function() {
        return (
            <div>
                <p>
                    <strong>Attempt to post as original format:</strong><br />
                    We will try to retain the original post type and share with similar formatting.
                </p>
                <p>
                    <strong>Post as Reel:</strong><br />
                    All posts will be formatted and sent as a Reel. Please note: Non-video posts will disregarded.
                </p>
                <p>
                    <strong>Post as Story:</strong><br />
                    All posts will be formatted and sent as a Story. Any message text will be excluded.
                </p>
                <p>
                    <strong>Standard Post:</strong><br />
                    All posts will be formatted and sent as a standard post and include any media.
                </p>
            </div>
        );
    },
    inputSourceSnapchat: function() {
        return (
            <div>
                <p>
                    <strong>Post as Story:</strong><br />
                    All posts will be formatted and sent as a Story. Posts will only be visible to your approved Snapchat audience. Non-video posts will disregarded.
                </p>
                <p>
                    <strong>Standard as Spotlight:</strong><br />
                    All posts will be formatted and sent as a Spotlight. Posts will be public and discoverable. Nonvideo posts will disregarded
                </p>
            </div>
        );
    },
    queueRateLimit: function() {
        let content = null,
            timezone = this.props.user.detail.timezone,
            resetDate = null;

        if (this.props.social.pubLimitReset !== undefined && this.props.social.pubLimitReset !== 0) {
            resetDate = moment.tz(this.props.social.pubLimitReset * 1000, timezone);

            content = (
                <div>
                    <p>You hit the post limit for your account before the scheduled post(s) could be made.</p>
                    <p>If you do nothing, scheduled post(s) will go out when your limit resets on {resetDate.format("MMM Do, Y")}.</p>
                    <p>You can always <Link to="/account/subcription">upgrade your plan</Link> to get unlimited monthly posting.</p>
                </div>
            );

        } else if (this.props.social.limitResetTs !== undefined && this.props.social.limitResetTs !== 0) {
            resetDate = moment.tz(this.props.social.limitResetTs * 1000, timezone);
            content = (
                <div>
                    <p>This post was scheduled after you used all your X posts for the current billing period.</p>
                    <p>If you do nothing, this post will go out when your post limit resets on {resetDate.format("MMM Do, Y")}.</p>
                    <p>You can always <Link to="/account/subcription">add more X Posts</Link> to meet your needs.</p>
                </div>
            );
        }

        return (
            <div>
                {content}
            </div>
        );
    }
};

class HelpButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            helpShown: false
        };

        this.toggleHelp = this.toggleHelp.bind(this);

    }

    toggleHelp(e) {

        let state = false;

        e.preventDefault();
        e.stopPropagation();

        if (this.state.helpShown === false) {
            state = true;
        }

        this.setState({
            helpShown: state
        });

    }

    render() {

        let helpBlock = null,
            blockClass = 'help-block',
            helpTrigger = null;

        if (this.props.which === 'cvv') {
            blockClass += ' cvv';
        }

        if (this.props.which === 'timezone') {
            blockClass += ' right-align';
        }

        if (this.state.helpShown) {
            helpBlock = (
                <div className={blockClass}>
                    <div className="help-copy">
                        {_helpMessages[this.props.which].apply(this, [this.props.service])}
                    </div>
                    <div className="close-help">
                        <button className="btn-primary reverse-fixed" onClick={this.toggleHelp}>
                            OK
                        </button>
                    </div>
                </div>
            )
        }

        helpTrigger = (
            <i className="fa fa-info-circle" onClick={this.toggleHelp} role="button" aria-label="get help"></i>
        );

        if (this.props.textButton) {
            helpTrigger = (
                <span className="help-text-trigger" onClick={this.toggleHelp} role="button" aria-label="get help">{this.props.textButton}</span>
            );
        }

        return (
            <div className="help-button" role="dialog">
                {helpTrigger}
                {helpBlock}
            </div>
        );
    }

};

HelpButton.propTypes = {
    which: PropTypes.string,
    service: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

HelpButton.defaultProps = {
    which: 'default',
    service: 0
};

export default HelpButton;
